/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdMaterialsGrid200,
  GetApiV1ClassroomdisciplineIdMaterialsGrid401,
  GetApiV1ClassroomdisciplineIdMaterialsGrid404,
  GetApiV1ClassroomdisciplineIdMaterialsGridPathParams,
  GetApiV1ClassroomdisciplineIdMaterialsGridQueryParams,
  GetApiV1ClassroomdisciplineIdMaterialsGridQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdMaterialsGrid.ts";
import { materialGridItemViewModelSchema } from "../materialGridItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdMaterialsGridPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsGridPathParams>;

export const getApiV1ClassroomdisciplineIdMaterialsGridQueryParamsSchema = z
  .object({
    culture: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdMaterialsGrid200Schema = z.array(
  z.lazy(() => materialGridItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsGrid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdMaterialsGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsGrid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdMaterialsGrid404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsGrid404>;

export const getApiV1ClassroomdisciplineIdMaterialsGridQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdMaterialsGrid200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsGridQueryResponse>;
